import { Form } from 'antd';
import type { NamePath } from '@xbcb/ui-types';
import {
  ComplianceCheckStatus,
  ComplianceCheckType,
} from '__generated__/graphql';
import { getLatestComplianceCheckStatus } from 'libs/complianceChecks';

// latest status of a compliance-check type for a line item.
export const useComplianceCheckStatus = (
  linePath: NamePath,
  type: ComplianceCheckType,
): ComplianceCheckStatus | undefined => {
  const form = Form.useFormInstance();
  const complianceChecks = Form.useWatch(
    [...(linePath as (string | number)[]), 'complianceChecks'],
    form,
  );
  return getLatestComplianceCheckStatus(complianceChecks, type);
};
